import { MapPin } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { fmtDate, CANTIERE_STATUS, CANTIERE_TONE } from "@/lib/format";
import { ProgressBar, Pill } from "@/components/rp";

const Stat = ({ label, value, testid }) => (
  <div className="rp-card px-5 py-4">
    <p className="rp-label">{label}</p>
    <p className="text-lg font-medium mt-1" data-testid={testid}>{value}</p>
  </div>
);

export const CantiereHero = ({ c, photosCount, children }) => (
  <div className="space-y-4 rp-fade">
    <div className="relative overflow-hidden rounded-[20px] h-[340px] sm:h-[420px] bg-[#EBEBEB]" data-testid="cantiere-hero">
      <img src={fileUrl(c.cover_url) || "/login.jpg"} alt={c.title} className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 p-6 sm:p-10 text-white">
        <div className="flex items-center gap-2 mb-3">
          <Pill tone={CANTIERE_TONE[c.status]}>{CANTIERE_STATUS[c.status]}</Pill>
        </div>
        <h1 className="text-3xl sm:text-5xl font-semibold tracking-tight" data-testid="cantiere-title">{c.title}</h1>
        {c.address && (
          <p className="flex items-center gap-1.5 text-white/80 mt-2 text-sm" data-testid="cantiere-address">
            <MapPin className="h-4 w-4" /> {c.address}
          </p>
        )}
        <div className="mt-6 max-w-xl">
          <div className="flex items-end justify-between mb-2">
            <div>
              <p className="text-[11px] uppercase tracking-[0.14em] text-white/70 font-semibold">Fase attuale</p>
              <p className="font-medium" data-testid="cantiere-current-phase">{c.current_phase}</p>
            </div>
            <p className="text-3xl font-semibold" data-testid="cantiere-progress-value">{c.progress}%</p>
          </div>
          <ProgressBar value={c.progress} dark data-testid="cantiere-progress-bar" />
        </div>
      </div>
    </div>
    <div className="grid grid-cols-3 gap-3">
      <Stat label="Inizio" value={fmtDate(c.start_date)} testid="cantiere-start-date" />
      <Stat label="Fine prevista" value={fmtDate(c.expected_end)} testid="cantiere-expected-end" />
      <Stat label="Foto" value={photosCount} testid="cantiere-photos-count" />
    </div>
    {children && <div className="flex flex-wrap gap-2 pt-1">{children}</div>}
  </div>
);
